/**
 * Created by christian on 2/26/2015.
 */


/*
getModules(): angular.IPromise<Array<EntityModuleView>>;
getRootEntities(moduleName:string): angular.IPromise<Array<EntityDefinitionView>>;
*/

module cr.entity
{
    class EntityService implements IEntityService {
        private $log: angular.ILogService;
        private url:string;

        getModuleDetail(moduleName:string): angular.IPromise<EntityModule>
        {
            var url=this.url+"module_detail/"+moduleName;
            this.$log.info("GET: " + url);

            var defer = this.$q.defer();

            this.$http({ url: url, method: "GET" })
                .success((data:any, status, headers, config) => {
                    defer.resolve(data);
                }).error((data:any)=>{ defer.reject() });

            return defer.promise;
        }

        getEntity(moduleName:string,entityName:string,entityId:string): angular.IPromise<any>
        {
            var url=this.url+"get/"+moduleName+"/"+entityName+"/"+entityId;
            this.$log.info("GET: " + url);

            var defer = this.$q.defer();

            this.$http({ url: url, method: "GET" })
                .success((data:any, status, headers, config) => {
                    defer.resolve(data);
                }).error((data:any)=>{ defer.reject() });

            return defer.promise;
        }

        search(fullPath:string,toSearch:string): angular.IPromise<DynamicTable>
        {
            var url=this.url+"search/"+encodeURI(fullPath)+"?search="+toSearch;
            this.$log.info("GET: " + url);

            var defer = this.$q.defer();

            this.$http({ url: url, method: "GET" })
                .success((data:DynamicTable, status, headers, config) => {
                    defer.resolve(data);
                }).error((data:any)=>{ defer.reject() });

            return defer.promise;
        }

        getModules(): angular.IPromise<Array<EntityModuleView>> {
            var url=this.url+"modules";
            this.$log.info("GET: " + url);

            var defer = this.$q.defer();

            this.$http({ url: url, method: "GET" })
                .success((data:Array<EntityModuleView>, status, headers, config) => {
                    defer.resolve(data);
                }).error((data:any)=>{ defer.reject() });

            return defer.promise;
        }

        addUpdate(fullPath:string,entity:any): angular.IPromise<any>{
            var url=this.url+"add-update/"+encodeURI(fullPath);
            this.$log.info("POST: " + url);

            var defer = this.$q.defer();

            this.$http.post(url, entity)
                .success((data:any, status, headers, config) => {
                    this.$log.log("addupdate: "+angular.toJson(data));
                    defer.resolve(data);
                })
                .error((data, status, headers, config) => {
                    defer.reject(data);
                });
            return defer.promise;
        }

        create(fullPath:string): angular.IPromise<any>{
            var url=this.url+"create/"+encodeURI(fullPath);
            this.$log.info("GET: " + url);

            var defer = this.$q.defer();

            this.$http({url: url,method:"GET"})
                .success((data:any, status, headers, config) => {
                    this.$log.log("create: "+angular.toJson(data));
                    defer.resolve(data);
                })
                .error((data, status, headers, config) => {
                    defer.reject(data);
                });
            return defer.promise;
        }

        getRootEntities(moduleName:string): angular.IPromise<Array<EntityDefinitionView>>
        {
            var url=this.url+"rootentities/"+moduleName;
            this.$log.info("GET: " + url);

            var defer = this.$q.defer();
            this.$http({ url: url, method: "GET" })
                .success((data:Array<EntityDefinitionView>, status, headers, config) => {
                    defer.resolve(data);
                }).error((data:any)=>{ defer.reject() });

            return defer.promise;
        }

        getFormDefinition(moduleName:string,entityName:string): angular.IPromise<any>
        {
            var url = "modules/entity/resources/"+moduleName+"."+entityName+".json";  // get from json
            return  this.$http({ url: url, method: "GET" });
        }

        constructor(public $http: angular.IHttpService, private $q: angular.IQService, $log:any, private cfg:cr.common.IConfig) {
            this.$log = $log.getInstance('EntityService');
            this.url=cfg.WebApiUrl+"data/entity/";
        }
    }

    // Module registrations.
    entityModule.factory('entityService', ['$http','$q','$log','cfg',($http,$q,$log,cfg)=>new EntityService($http,$q,$log,cfg)]);

}
